'use strict';

const tracking = require('dibs-tracking');
const SV = require('server-vars');
const get = require('lodash.get');

function getSVTrackingData(query, subType) {
    return SV.get(`${query}.${subType}`) || SV.get(query);
}

function track({type, subType, step, action: trackAction}) {
    const {category, action} = getSVTrackingData(`tourCopy.${type}.tracking`, subType) || {};
    const label = get(getSVTrackingData(`tourCopy.${type}.step${step}`, subType), `tracking.${trackAction}`);

    if (category && action && label) {
        tracking.trackEvent({category, action, label});
    }
}

const tourTracking = {

    trackOpen(payload) {
        const action = 'open';
        track(Object.assign({action}, payload));
    },

    trackClose(payload) {
        const action = 'close';
        track(Object.assign({action}, payload));
    },

    trackCta(payload) {
        const action = 'cta';
        track(Object.assign({action}, payload));
    },

    trackComplete(payload) {
        const action = 'complete';
        track(Object.assign({action}, payload));
    }

};

module.exports = tourTracking;



// WEBPACK FOOTER //
// ./assets/js/global/tracking/tourTracking.es.js